import { Grid, Typography } from "@mui/material";
import ContactInfoBlock from "../Contact/components/ContactInfoBlock.tsx";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Contact } from "../../../types";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import CustomInfoBox from "../../CustomComponents/CustomInfoBox.tsx";
import CustomIconButton from "../../CustomComponents/CustomIconButton.tsx";

const HomeSection = () => {
	const socialMedias: Contact[] = [
		{ method: "Instagram", url: "https://www.instagram.com/jiro.kakpovbia", icon: InstagramIcon },
		{ method: "X (formerly Twitter)", url: "https://x.com/JiroKakpovbia", icon: XIcon },
		{
			method: "LinkedIn",
			url: "https://linkedin.com/in/jiro-kakpovbia",
			icon: LinkedInIcon,
		},
		{ method: "Github", url: "https://github.com/JiroKakpovbia", icon: GitHubIcon },
	];

	return (
		<section id={"home"}>
			<Grid container size={12} alignItems={"center"} padding={3} minHeight={"100dvh"}>
				{/* Animation */}
				<Grid
					container
					sx={{
						position: "absolute",
						inset: 0,
						zIndex: 0,
						alignItems: "center",
						justifyContent: "center",
						pointerEvents: "none",
					}}
				>
					<CustomInfoBox
						transparent
						sx={{
							width: {
								xs: "200%",
								sm: "80%",
								md: "60%",
								lg: "50%",
								xl: "40%",
							},
							aspectRatio: "1 / 1",
						}}
					>
						<DotLottieReact
							src={"https://lottie.host/a367f2aa-4068-44af-b626-4e55960578dc/Xla2bWkpIb.lottie"}
							loop
							autoplay
							data-aos={"fade-in"}
							data-aos-once={"true"}
							data-aos-delay={500}
						/>
					</CustomInfoBox>
				</Grid>
				<Grid container size={12} justifyContent={"center"}>
					{/* Content */}
					<Grid container size={12} justifyContent={"center"} textAlign={"center"} spacing={3}>
						{/* Text */}
						<Grid size={12} data-aos={"fade-down"} data-aos-once={"true"}>
							<Typography variant={"h5"} component={"h2"}>
								Hi, my name is
							</Typography>
						</Grid>
						<Grid size={12} data-aos={"fade-in"} data-aos-once={"true"}>
							<Typography variant={"h2"}>Jiro Kakpovbia</Typography>
						</Grid>
						<Grid size={12} data-aos={"fade-up"} data-aos-once={"true"}>
							<Typography variant={"h5"} component={"h2"}>
								Full-Stack Software Developer
							</Typography>
						</Grid>
					</Grid>
					{/* Social Media */}
					<Grid container size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }} justifyContent={"center"} data-aos={"fade-up"} data-aos-once={"true"}>
						<ContactInfoBlock contactMethods={socialMedias} sizing={3} background={false} />
					</Grid>
				</Grid>
			</Grid>

			{/* Advance Arrow */}
			<Grid
				container
				size={12}
				justifyContent={"center"}
				data-aos={"fade-up"}
				data-aos-once={"true"}
				data-aos-delay={1000}
				sx={{
					position: "absolute",
					bottom: 100,
					left: 0,
					right: 0,
					zIndex: 1,
				}}
			>
				<CustomIconButton icon={ExpandCircleDownIcon} component={"a"} aria-label={"Advance to About section"} href={`#about`} />
			</Grid>
		</section>
	);
};

export default HomeSection;
